import React from "react";
import category_img from "../../assets/images/category-img.png";
import login_logo from "../../assets/images/login-logo.png";
import category_ico1 from "../../assets/images/category-icon1.png";
import category_ico2 from "../../assets/images/category-icon2.png";
import { Link } from "react-router-dom";
import { AUTH } from "../../Router/paths";
import { useLocation } from "react-router-dom";

function CategoryBoxes() {
  const { state } = useLocation();
  return (
    <div className="categ-sec pc-p-4">
      <div className="container-fluid px-5">
        <div className="row align-items-center">
          <div className="col-lg-6 col-md-6 col-12">
            <div className="side-img px-5">
              <img src={category_img} alt="Login" />
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-12">
            <div className="login-form">
              <div className="login-logo mb-5">
                <img src={login_logo} alt="Logo" />
              </div>
              <div className="login-content signup-content text-center">
                <h4 className="mb-3">Choose Your Account Type</h4>
                <div className="category-sec">
                  <div className="category-sec-box mb-3">
                    <Link to={AUTH.clientProfile} state={state}>
                      <div className="category-icon">
                        <img src={category_ico1} alt="Category" />
                      </div>
                      <div className="category-content">
                        <h3>Work As Client</h3>
                      </div>
                    </Link>
                  </div>
                  <div className="category-sec-box">
                    <Link to={AUTH.freelancerProfile} state={state}>
                      <div className="category-icon">
                        <img src={category_ico2} alt="Category" />
                      </div>
                      <div className="category-content">
                        <h3>Work As Freelancer</h3>
                      </div>
                    </Link>
                  </div>
                </div>

                {/* <h5>
                  Already have an account?{" "}
                  <Link to={AUTH.login} className="color-primary">
                    {" "}
                    Log In{" "}
                  </Link>
                </h5> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CategoryBoxes;
